import React from 'react';
import { AdminUsersListView } from './adminUsersListView';
import { useGetAllUsersQuery, useUpdateUserMutation } from '../../../api/userApi';
import { useGetCompaniesQuery } from '../../../api/companyApi';
import { LoadingIndicator } from '../../shared/alerts/loadingIndicator';
import { useToast } from '../../../hooks/useToast';
import { hashPassword } from '../../../api/authApi';

export const AdminUsersListViewContainer: React.FC = () => {
  const { data: users, isLoading: loadingUsers, error: usersError, refetch } = useGetAllUsersQuery();
  const { data: companies, isLoading: loadingCompanies } = useGetCompaniesQuery();
  const [updateUser, { isLoading: isUpdating }] = useUpdateUserMutation();
  const { showSuccess, showError } = useToast();

  const handleResetPassword = async (userId: string) => {
    try {
      // Find the user
      const user = users?.find(u => u.id === userId);
      if (!user) {
        showError('User not found');
        return;
      }

      // Generate temporary password
      const tempPassword = 'TempPass123';
      const hashedPassword = hashPassword(tempPassword);

      // Update user with new password
      await updateUser({
        id: userId,
        data: { password: hashedPassword }
      }).unwrap();

      showSuccess(`Password reset for ${user.email}. Temporary password: ${tempPassword}`);
      refetch();
    } catch (error: any) {
      showError(`Failed to reset password: ${error.message || 'Unknown error'}`);
    }
  };

  if (loadingUsers || loadingCompanies) return <LoadingIndicator message='Loading companies' />;
  if (usersError) return <div>Error loading users</div>;
  if (!users) return <div>No users found</div>;

  const companyOptions = companies?.map(company => ({
    id: company.id,
    name: company.name
  })) || [];

  return (
    <AdminUsersListView
      users={users}
      companies={companyOptions}
      onResetPassword={handleResetPassword}
      isResettingPassword={isUpdating}
    />
  );
};

